import memoize from 'lodash/memoize';
import reactReplacePlaceholder from 'react-replace-placeholder';

import makePluralKey, {
  DEFAULT_MAX_VARIANTS,
  DEFAULT_PLURAL_SUFFIX,
} from './make-translations-plural-key';

import type {
  TranslationServiceType,
  Translate,
  TranslatePlural,
} from '@web-platform/shared-travel-tools-types/src/translation-service';

const TranslationService: TranslationServiceType = ({ logger, translations }) => {
  const lookup = (key: string, replacements = {}, startTag = '{', endTag = '}') => {
    const message = translations[key];
    if (!message) {
      // Only log if key is not undefined/null to avoid logging undefined
      if (key) {
        logger.warn(`Missing translation for key "${key}"`);
      }
      return '';
    }
    if (!replacements || Object.keys(replacements).length === 0) {
      return message;
    }
    return memoize(reactReplacePlaceholder)(message, replacements, startTag, endTag).join('');
  };

  const translate: Translate = (key, replacements, startTag, endTag) =>
    lookup(key, replacements ?? {}, startTag, endTag);

  const translatePlural: TranslatePlural = (
    key,
    cardinality,
    replacementKey,
    {
      endTag = '}',
      extra = DEFAULT_PLURAL_SUFFIX,
      extraReplacements = {},
      maxVariants = DEFAULT_MAX_VARIANTS,
      startTag = '{',
    } = {},
  ) => {
    const pluralKey = makePluralKey(key, cardinality, maxVariants, extra);

    const replacements = { ...extraReplacements };
    if (cardinality > maxVariants) {
      replacements[replacementKey] = cardinality;
    }

    return lookup(pluralKey, replacements, startTag, endTag);
  };

  return {
    translate,
    translatePlural,
  };
};

export { TranslationService };
